<template>
  <section :style="backgroundStyle">
    <header v-if="isTitle">
      <img v-if="titleIcon" class="title-icon" :src="titleIcon" alt="icon">
      <!-- <b v-else :style="{background: color}"></b> -->
      {{title}}
      <i v-if="tips" @click="tip"></i>
    </header>

    <div class="content" :style="isTitle?'padding-top:20px':''">
      <slot></slot>
    </div>
  </section>
</template>

<script>
  export default {
    name: "SectionView",

    props: {
      // 标题
      title: {
        type: String,
        require: true,
      },
      // 颜色
      color: {
        type: String,
        default: '#6CA0EC',
      },
      // 是否启用提示按钮
      tips: {
        type: Boolean,
        default: false,
      },
      // 背景图片
      backgroundImage: {
        type: String,
        default: '',
      },
      // 标题图标路径
      titleIcon: {
        type: String,
        default: '',
      },
      isTitle: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      backgroundStyle() {
        let style = {
          // 默认背景色
          // backgroundColor: '#FFFFFF'
        };
        
        // 设置背景图片（如果有）
        if (this.backgroundImage) {
          // 保留背景色，添加背景图片
          style.backgroundImage = `url(${this.backgroundImage})`;
          style.backgroundRepeat = 'no-repeat';
          style.backgroundPosition = 'center center';
          style.color = 'transparent';
          style.backgroundSize = 'cover';
          !this.isTitle?style.marginTop = 0:'';
        }
        
        return style;
      }
    },

    methods: {
      tip() {
        this.$emit('tip');
      }
    }
  }
</script>

<style lang="scss" scoped>
  section {
    border-radius: 20px;
    padding: 15px 20px;
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 40px;

    header {
      position: relative;
      height: 36px;
      font-size: 36px;
      font-weight: 500;
      color: #00133D;
      // margin-left: 30px;
      display: flex;
      align-items: center;

      b {
        content: "";
        display: block;
        width: 14px;
        height: 100%;
        background: #6CA0EC; // Default color, will be overridden by :style
        border-radius: 7px;
        margin-right: 10px;
      }

      .title-icon {
        width: 45px; // Or adjust size as needed
        height: 45px; // Or adjust size as needed
        margin-right: 10px;
        vertical-align: middle; // Align icon vertically with text
      }

      i {
        position: absolute;
        right: 0;
        width: 34px;
        height: 34px;
        background: url("../assets/question.png") no-repeat;
        background-size: 34px 34px;

        &:active {
          opacity: 0.5;
        }
      }
    }

    .content {
      position: relative;
      //padding-top: 40px;
    }
  }
</style>
